module.exports = __webpack_public_path__ + "img/banner_collect_2.47520d9a.png";